import { Flex } from "@mantine/core";

import { useInvoice } from "../../../api/hooks/invoice/useInvoice.ts";
import Preloader from "../../../components/Preloader/Preloader.tsx";
import CollectionActivityHistory from "./CollectionActivityHistory/CollectionActivityHistory.tsx";
import InvoiceBreadcrumbs from "./InvoiceBreadcrumbs/InvoiceBreadcrumbs.tsx";
import InvoiceDetailsCards from "./InvoiceDetailsCards/InvoiceDetailsCards.tsx";
import PaymentHistory from "./PaymentHistory/PaymentHistory.tsx";

interface InvoiceDetailsProps {
  invoiceId: number;
  onBreadcrumbsClick?: () => void;
}

const InvoiceDetailTab = ({
  invoiceId,
  onBreadcrumbsClick,
}: InvoiceDetailsProps) => {
  const [{ data: invoiceData, fetching: isLoading }] = useInvoice({
    id: invoiceId,
  });
  const invoice = invoiceData?.invoice;

  if (!invoiceId) {
    return;
  }

  if (isLoading || !invoice) {
    return <Preloader loading={true} />;
  }

  return (
    <>
      <Flex direction="column" gap={20}>
        <InvoiceBreadcrumbs
          invoice={invoice}
          onBreadcrumbsClick={onBreadcrumbsClick}
        />
        <InvoiceDetailsCards invoice={invoice} />
        <CollectionActivityHistory invoiceId={invoice.id} />
        <PaymentHistory invoiceId={invoice.id} />
      </Flex>
    </>
  );
};

export default InvoiceDetailTab;
